import oscript from './lib/oscript'
import ojson from './lib/ojson'
import resultHighlighter from './lib/resultHighlighter'

export default {
	oscript,
	ojson,
	resultHighlighter
}
